import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle2, Loader2, AlertTriangle } from 'lucide-react';
import api from '../services/api';

const GOLD = '#C9A961';

export default function PreRegisterSuccess() {
  const [params] = useSearchParams();
  const sid = params.get('session_id');
  const [data, setData] = useState(null);
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sid) return;
    let t;
    api.get(`/preregister/status/${sid}`).then((r) => {
      setData(r.data);
      if (r.data.payment_status === 'pending' && tries < 8) t = setTimeout(() => setTries((n) => n + 1), 2500);
    }).catch(() => setData({ payment_status: 'error' }));
    return () => clearTimeout(t);
  }, [sid, tries]);

  const paid = data?.payment_status === 'paid';
  const waiting = sid && (!data || (data.payment_status === 'pending' && tries < 8));

  return (
    <div className="min-h-screen text-white" style={{ backgroundColor: '#050508' }} data-testid="preregister-success-page">
      <div className="max-w-xl mx-auto px-5 pt-20 pb-20 text-center">
        {waiting ? (
          <div data-testid="prereg-status-checking"><Loader2 className="w-8 h-8 animate-spin mx-auto" style={{ color: GOLD }} /><p className="text-gray-400 text-sm mt-4">Confirming your payment…</p></div>
        ) : paid ? (
          <div data-testid="prereg-status-paid">
            <CheckCircle2 className="w-14 h-14 mx-auto text-emerald-400" />
            <h1 className="text-4xl font-black uppercase tracking-tight mt-5">Your Seat Is Held.</h1>
            <p className="text-gray-300 mt-4 text-sm leading-relaxed"><strong>{data.student_name}</strong> is pre-registered for the 2027–28 school year ({data.grade === 'K' ? 'Kindergarten' : `Grade ${data.grade}`}). A confirmation email is on its way to you.</p>
            <div className="mt-6 inline-block border-2 px-5 py-3 text-xs tracking-[0.25em] uppercase" style={{ borderColor: `${GOLD}55`, color: GOLD }} data-testid="prereg-confirmation">Confirmation #{data.confirmation}</div>
          </div>
        ) : (
          <div data-testid="prereg-status-unpaid">
            <AlertTriangle className="w-12 h-12 mx-auto text-amber-400" />
            <h1 className="text-2xl font-black uppercase mt-4">We couldn't confirm payment yet</h1>
            <p className="text-gray-400 text-sm mt-3">If you completed payment, you'll receive a confirmation email shortly. Otherwise, please <a href="/preregister" className="underline text-white">try again</a> or email info@prsvr.com.</p>
          </div>
        )}
      </div>
    </div>
  );
}
